var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.viewType === 'moodview')?_c('div',{staticClass:"card-top top-image"},[_c('lightbox',{attrs:{"images":_vm.image,"thumbnailSrc":"source","src":"source","customImageClass":"hover","compressThumbnail":false}}),_c('div',{staticClass:"close-moodview hover",on:{"click":_vm.closeMoodview}},[_c('i',{staticClass:"fal fa-times"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }